module.exports = __webpack_public_path__ + "static/media/022.1f00c995.jpg";